module.exports = __webpack_public_path__ + "media/images/PP_logo_h_100x26-3bcb41b2952c1fa1048be21e73b18548.png";